import { Modal, ModalBody } from "@vds/modals";
import { Icon } from "@vds/icons";
import { Title, Body } from "@vds/typography";
import { useState, useEffect } from "react";
import { SLButton } from "../../components/core/Controls";
import { FlexRow, Spacer } from "../../components/core/Utility/index";
import { css } from "@emotion/react";
import { DropdownSelect } from "@vds/selects";
import styled from "styled-components";
import { getAllReasonsData } from "../../services/C4S Decommission - Replacement/getAllReasonsData";
import UpdateAddressContactModal from "./UpdateAddressContactModal";
import { CustomSLButton } from "../../components/core/utility";
import { Loader } from "@vds/loaders";
import { buildReturnReshipPayload, returnReship } from "../../services/C4S Decommission - Replacement/returnsHelper";
import { switchTab } from "./utils";
import { getWorkTicketHistoryFromSession } from "./navigation/tabHelpers";

export const CustomDropdown = styled(DropdownSelect)`
  & div {
    height: 2rem;
    & span {
      & span {
        & div {
          & select {
            padding: 0.2rem 1rem 0.2rem 0.5rem;
            font-size: 12px;
            color: ${(props) => (props.disabled || props.disableValue ? "#666b6b" : "")};
            text-wrap: wrap;
            line-height: 0.8rem;
            &:disabled {
              -webkit-text-fill-color: #000000;
              background-color: #ffffff;
              border-bottom: 1px solid #000000;
              opacity: ${(props) => (props.disabled ? "0.4" : "")};
            }
          }
          & span {
            top: 0.35rem;
            right: 0.5rem;
            & svg {
              width: 0.8rem;
              height: 0.8rem;
              min-width: 0.8rem;
              min-height: 0.8rem;
              display:${(props) => (props.hideErrorImg ? "none !important" : "")};
            }
          }
        }
        & div {
          & div {
            & p {
              display: none;
            }
          }
        }
      }
      }
    }
  }
`;

export const StyledModal = css`
  max-height: 99vmin;
  padding: 1rem 1rem 1rem 1rem;
  padding-right: 2px;
  width: 50vw;
  @media (max-width: 767px) {
    width: 560px !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }

  & footer {
    padding: 0;
  }
`;

const WTCommonModal = ({
  setCommonModalStatus,
  handleCancelShipment,
  notify,
  title,
  subTitle,
  actionItem,
  handleShipmentDamagedModal,
  handleLostShipmentModal,
  ticketDetails,
  handleContactModal,
  modal,
}) => {
  const cspSessionData = JSON.parse(sessionStorage.getItem("CSPDetails"));
  const [reason, setReason] = useState({});
  const [rejectReasons, setRejectReasons] = useState([]);
  const [isLoading, setLoader] = useState(false);
  const [showUpdateAddressModal, setShowUpdateAddressModal] = useState(false);
  const [addressContactPayload, setAddressContactPayload] = useState(null); // Store the payload from address update
  const [showReturnReshipModal, setShowReturnReshipModal] = useState(false);
  const [returnReshipPayload, setReturnReshipPayload] = useState(null);

  const changeRescheduleReason = (e) => {
    let selectedReason = rejectReasons.filter((item) => item.description === e.target.value)[0];
    setReason(selectedReason);
  };

  useEffect(() => {
    setReason({}); // Reset selected reason when actionItem changes
    fetchReasonsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionItem]);

  const fetchReasonsData = async () => {
    setLoader(true);
    let reasonsResponse;
    if (actionItem === "CancelShipment") {
      reasonsResponse = await getAllReasonsData("WTA_CNC_WT");
    } else if (actionItem === "ReturnReshipShipped" || actionItem === "ReturnReshipDelivered") {
      reasonsResponse = await getAllReasonsData("WTA_RET_RSP");
    } else if (actionItem === "ReshipOnlyShipped" || actionItem === "ReshipOnlyDelivered") {
      reasonsResponse = await getAllReasonsData("WTA_RSP_RTS");
    } else if (actionItem === "ReturnOnly") {
      reasonsResponse = await getAllReasonsData("WTA_RET_RSP");
    } else if (actionItem === "DamagedPackage" || actionItem === "Damaged_Lost_Package") {
      reasonsResponse = await getAllReasonsData("WTA_DMG_PKG");
    } else if (actionItem === "LostPackage") {
      reasonsResponse = await getAllReasonsData("WTA_LST_PKG");
    } else if (actionItem === "return") {
      reasonsResponse = await getAllReasonsData("WTA_RSP_ROR");
    } else if (actionItem === "return_reship") {
      reasonsResponse = await getAllReasonsData("WTA_RSP_RRR");
    }

    if (reasonsResponse?.status === 200 && reasonsResponse?.data?.data?.length) {
      const data = reasonsResponse.data?.data;
      if (actionItem === "ReturnReshipShipped") {
        const tempNoShowReasons = data.filter((data) => data.subCode === "RET_RSP_RS");
        setRejectReasons(tempNoShowReasons);
      } else setRejectReasons(data);

      setLoader(false);
    } else {
      setLoader(false);
      notify("Unable to fetch Processing Codes due to an unexpected error.", "error");
    }
  };

  const submitReturnReshipRequest = async (updatedAddressPayload = null) => {
    const addressPayload = updatedAddressPayload || addressContactPayload;
    setLoader(true);
    let action, returnReason, returnSubReason;

    if (actionItem === "LostPackage") {
      action = "Return/Reship";
      returnReason = "Lost Shipment";
      returnSubReason = reason?.description || "";
    } else if (actionItem === "DamagedPackage") {
      action = "Return/Reship";
      returnReason = "Shipment Damaged";
      returnSubReason = reason?.description || "";
    } else if (actionItem === "ReshipOnlyShipped" || actionItem === "ReshipOnlyDelivered") {
      action = "Reship";
      returnReason = reason?.description || "";
      returnSubReason = "";
    } else if (actionItem === "ReturnOnly") {
      action = "Return";
      returnReason = reason?.description || "";
      returnSubReason = "";
    } else {
      action = "Return/Reship";
      returnReason = reason?.description || "";
      returnSubReason = "";
    }

    const payload = buildReturnReshipPayload({
      ticketDetails,
      cspDetails: cspSessionData,
      action: action === "Return/Reship" ? "Reship" : action,
      returnReason,
      returnSubReason,
      addressPayload,
    });

    const response = await returnReship(payload);
    if (response?.status === 200 && response?.data) {
      notify(action + " processed successfully", "success");
      setCommonModalStatus(false);
      switchTab(getWorkTicketHistoryFromSession());
    } else {
      notify("Unable to update workticket due to an unexpected error", "error");
    }
    setLoader(false);
  };

  const handleConfirmation = async () => {
    if (reason.description && reason.description.toLowerCase().includes("wrong address")) {
      setShowUpdateAddressModal(true);
    } else if (reason.description && reason.description.toLowerCase().includes("return to sender")) {
      setShowUpdateAddressModal(true);
    } else if (
      (actionItem === "LostPackage" || actionItem === "DamagedPackage") &&
      (reason.subCode === "LST_UPS" ||
        reason.subCode === "LST_CUS" ||
        reason.subCode === "LST_VZC" ||
        reason.subCode === "DMG_UPS" ||
        reason.subCode === "DMG_CUS") &&
      (reason.description.toLowerCase().includes("courier (ups)") ||
        reason.description.toLowerCase().includes("customer") ||
        reason.description.toLowerCase().includes("vzc"))
    ) {
      setShowUpdateAddressModal(true);
    } else if (actionItem === "CancelShipment") {
      handleCancelShipment(reason.description, reason.subCode);
    } else if (actionItem === "LostPackage" || actionItem === "DamagedPackage") {
      setShowReturnReshipModal(true);
    } else if (
      actionItem === "ReturnReshipShipped" ||
      actionItem === "ReturnReshipDelivered" ||
      actionItem === "ReshipOnlyShipped" ||
      actionItem === "ReshipOnlyDelivered"
    ) {
      if (reason.description === "Shipment Damaged" && reason.subCode === "RET_RSP_SD") {
        handleShipmentDamagedModal();
      } else if (reason.description === "Lost Shipment" && reason.subCode === "RET_RSP_RS") {
        handleLostShipmentModal();
      } else {
        await submitReturnReshipRequest();
      }
    } else if (actionItem === "return" || actionItem === "return_reship" || actionItem === "Damaged_Lost_Package") {
      setCommonModalStatus(false);
      if (reason.description === "Shipment damaged" && reason.subCode === "RRR_SHD") {
        handleShipmentDamagedModal(reason.description, "reason");
      } else if (reason.description === "Shipment lost" && reason.subCode === "RRR_SLT") {
        handleShipmentDamagedModal(reason.description, "reason");
      } else if (reason.description === "Courier (UPS)" && reason.subCode === "DMG_UPS") {
        handleContactModal(reason.description, "subReason");
      } else if (reason.description === "Customer" && reason.subCode === "DMG_CUS") {
        handleContactModal(reason.description, "subReason");
      } else {
        handleContactModal(reason.description, "reason");
      }
    } else {
      setCommonModalStatus(false);
    }
  };

  const handleAddressUpdateSuccess = async (flagData) => {
    setShowUpdateAddressModal(false);

    if (flagData && flagData.payload) {
      setAddressContactPayload(flagData.payload);
    }

    if (flagData && flagData.addressUpdateSuccess === true && flagData.customAction === "proceedToReturnReship") {
      setShowReturnReshipModal(true);
      setReturnReshipPayload(flagData.payload);
    } else {
      setCommonModalStatus(false);
    }
  };

  const handleReturnReshipComplete = async () => {
    await submitReturnReshipRequest(returnReshipPayload);
    closeAllModals();
  };

  const closeAllModals = () => {
    setShowReturnReshipModal(false);
    setShowUpdateAddressModal(false);
    setCommonModalStatus(false);
  };

  return (
    <>
      <Loader active={isLoading} fullscreen={false} />
      {!showUpdateAddressModal && !showReturnReshipModal && (
        <Modal
          id="Common Modal"
          ariaLabel="Common Modal"
          opened={true}
          fullScreenDialog={false}
          disableOutsideClick={true}
          css={StyledModal}
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <Title size="medium">{title}</Title>
              <div onClick={() => setCommonModalStatus(false)} css={{ marginRight: "1rem", marginTop: "0.3rem" }}>
                <Icon
                  role="img"
                  aria-label="close"
                  alt="close-icon"
                  name="close"
                  size="medium"
                  color="#000000"
                  style={{ cursor: "pointer", outline: "none" }}
                />
              </div>
            </FlexRow>
          }
        >
          <ModalBody css={{ paddingLeft: "0", paddingRight: "0" }}>
            <Spacer top="1rem" />
            <div style={{ padding: "5px", paddingBottom: "0px", width: "70%", fontSize: "13px" }}>
              <CustomDropdown
                type="text"
                tabIndex={0}
                ariaLabel={subTitle}
                label={subTitle}
                value={reason.description || "Please Select"}
                onChange={(e) => changeRescheduleReason(e)}
                placeholder="Please Select"
              >
                <>
                  <option disabled>Please Select</option>
                  {rejectReasons?.map((code) => (
                    <option key={code?.id}>{code?.description}</option>
                  ))}
                </>
              </CustomDropdown>
            </div>
          </ModalBody>
          <FlexRow css={{ justifyContent: "flex-end", paddingTop: "6.5rem" }}>
            <SLButton aria-label="Cancel" secondary role="button" size="large" css={{ width: "10rem" }} onClick={() => setCommonModalStatus(false)}>
              Cancel
            </SLButton>
            <SLButton
              size="large"
              aria-label="Save"
              role="button"
              css={{ width: "10rem" }}
              disabled={!reason.code}
              onClick={() => {
                handleConfirmation();
              }}
            >
              Save
            </SLButton>
          </FlexRow>
        </Modal>
      )}

      {showUpdateAddressModal && (
        <UpdateAddressContactModal
          setIsAddressUpdateModal={setShowUpdateAddressModal}
          notify={notify}
          ticketDetails={ticketDetails}
          onAddressUpdated={handleAddressUpdateSuccess}
          shouldOpenReturnReship={true} // Flag to indicate this will open return/reship modal
          initialFlags={{
            source: "commonModal",
            actionType: actionItem,
            timestamp: new Date().toISOString(),
          }} // Send some initial flags to the modal
        />
      )}

      {showReturnReshipModal && (
        <Modal
          role="dialog"
          ariaLabel="Return Reship Confirmation"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ paddingLeft: "0.7rem" }}>
                <Title size="medium">
                  {modal === "Reship" ? `${ticketDetails.ticketId} - Reship` : `${ticketDetails.ticketId}  - Return/Reship`}
                </Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => closeAllModals(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody css={{ padding: "16px 0 16px 16px !important" }}>
            {modal === "Reship" ? (
              <>
                <p style={{ "font-family": "Verizon-NHG-eTX" }}>You are about to process a reship for this work ticket.</p>
              </>
            ) : (
              <>
                <p style={{ "font-family": "Verizon-NHG-eTX" }}>You are about to process a return and reship for this work ticket.</p>
              </>
            )}
            <p style={{ "font-family": "Verizon-NHG-eTX" }}>Are you sure you want to continue?</p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <FlexRow>
              <CustomSLButton aria-label="No" role="button" secondary onClick={closeAllModals}>
                Cancel
              </CustomSLButton>
              <CustomSLButton
                aria-label="Yes"
                role="button"
                css={{ padding: "0 10px 0 10px" }}
                primary
                onClick={() => handleReturnReshipComplete(reason.description, reason.subCode)}
              >
                Continue
              </CustomSLButton>
            </FlexRow>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default WTCommonModal;
